import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function AssignmentIcon(props: IconProps) {
    return <Icon {...props} iconKey={"assignment"}/>
}
